import i18n from "@i18n";

// === General ===
const getAlignsX = () => {
  return [
    {
      value: "start",
      thumbnails: {
        default: "/images/align_x/left_default.png?v=1",
        hover: "/images/align_x/left_hover.png?v=1",
        active: "/images/align_x/left_active.png?v=1",
        disabled: "/images/align_x/left_disabled.png?v=1",
      },
    },
    {
      value: "center",
      thumbnails: {
        default: "/images/align_x/center_default.png?v=1",
        hover: "/images/align_x/center_hover.png?v=1",
        active: "/images/align_x/center_active.png?v=1",
        disabled: "/images/align_x/center_disabled.png?v=1",
      },
    },
    {
      value: "end",
      thumbnails: {
        default: "/images/align_x/right_default.png?v=1",
        hover: "/images/align_x/right_hover.png?v=1",
        active: "/images/align_x/right_active.png?v=1",
        disabled: "/images/align_x/right_disabled.png?v=1",
      },
    },
  ];
};
const getAlignsY = () => {
  return [
    {
      value: "start",
      thumbnails: {
        default: "/images/align_y/top_default.png?v=1",
        hover: "/images/align_y/top_hover.png?v=1",
        active: "/images/align_y/top_active.png?v=1",
      },
    },
    {
      value: "center",
      thumbnails: {
        default: "/images/align_y/middle_default.png?v=1",
        hover: "/images/align_y/middle_hover.png?v=1",
        active: "/images/align_y/middle_active.png?v=1",
      },
    },
    {
      value: "end",
      thumbnails: {
        default: "/images/align_y/bottom_default.png?v=1",
        hover: "/images/align_y/bottom_hover.png?v=1",
        active: "/images/align_y/bottom_active.png?v=1",
      },
    },
  ];
};
const getDateRanges = (language = i18n.locale) => {
  return [
    {
      id: "this_month",
      label: i18n.messages[language]["engine.common.dateRange.thisMonth"],
    },
    {
      id: "last_7_days",
      label: i18n.messages[language]["engine.common.dateRange.last7Days"],
    },
    {
      id: "last_30_days",
      label: i18n.messages[language]["engine.common.dateRange.last30Days"],
    },
    {
      id: "last_3_months",
      label: i18n.messages[language]["engine.common.dateRange.last3Months"],
    },
    {
      id: "last_6_months",
      label: i18n.messages[language]["engine.common.dateRange.last6Months"],
    },
  ];
};
const getSortByList = (language = i18n.locale, type = "datecreate") => {
  const types = {
    datecreate: [
      {
        id: "recently",
        label: i18n.messages[language]["engine.commonProduct.sortBy.recently"],
      },
      {
        id: "early",
        label: i18n.messages[language]["engine.commonProduct.sortBy.early"],
      },
    ],
    best_seller: [
      // for product
      {
        id: "income",
        label: i18n.messages[language]["engine.commonProduct.sortBy.income"],
      },
      {
        id: "item",
        label: i18n.messages[language]["engine.commonProduct.sortBy.item"],
      },
    ],
    'widget_album': [
      { id: "recently", label: i18n.messages[language]['engine.common.sortBy.recently'] },
      { id: "date_added", label: i18n.messages[language]['engine.common.sortBy.dateAdded'] },
      { id: "", label: i18n.messages[language]['engine.common.sortBy.numberOrder'] },
    ],
    'widget_content': [
      { id: "recently", label: i18n.messages[language]['engine.common.sortBy.recently'] },
      { id: "date_added", label: i18n.messages[language]['engine.common.sortBy.dateAdded'] },
      { id: "number_order", label: i18n.messages[language]['engine.common.sortBy.numberOrder'] },
    ]
  };
  return types[type];
};
const getNumItems = (type = 'page', numColumn = 4) => {
  if (type == 'page') {
    const objNumItemsByColumn = {
      3: [
        { value: 15, label: '15' },
        { value: 30, label: '30' },
        { value: 45, label: '45' },
        { value: 60, label: '60' },
        { value: 75, label: '75', isEnable: false },
      ],
      4: [
        { value: 20, label: '20' },
        { value: 40, label: '40' },
        { value: 60, label: '60' },
        { value: 80, label: '80' },
        { value: 100, label: '100', isEnable: false },
      ],
      5: [
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 75, label: '75' },
        { value: 100, label: '100' },
        { value: 125, label: '125', isEnable: false },
      ],
      6: [
        { value: 30, label: '30' },
        { value: 60, label: '60' },
        { value: 90, label: '90' },
        { value: 120, label: '120' },
        { value: 150, label: '150', isEnable: false },
      ],
    }
    return objNumItemsByColumn[numColumn]
  } else if (type == 'widget') { 
    return Array(40).fill().map((_, i) => {
      return { 
        value: i + 1, 
        label: i + 1 
      };
    });
  } else if (type == 'page_album' || type == 'page_all_blog_02' || type == 'page_all_blog_03' || type == 'page_all_blog_04' || type == 'page_all_blog_05') {
    return [
      { value: 24, label: '24' },
      { value: 48, label: '48' },
      { value: 72, label: '72' },
      { value: 96, label: '96' },
      { value: 120, label: '120', isEnable: false },
    ]
  } else if (type == 'page_all_blog_01') {
    return [
      { value: 28, label: '28' },
      { value: 55, label: '55' },
      { value: 82, label: '82' },
      { value: 109, label: '109' },
      { value: 137, label: '137', isEnable: false },
    ]
  }

  else return [];
};
const getImageRatios = (language = i18n.locale, includes = []) => {
  let imageRatios = [
    {
      value: "square",
      text: i18n.messages[language]["engine.common.imageRatio.square"],
      thumbnails: {
        default: "/images/image_ratioes/square_default.png",
        hover: "/images/image_ratioes/square_hover.png",
        active: "/images/image_ratioes/square_hover.png",
      },
    },
    {
      value: "horizontal",
      text: i18n.messages[language]["engine.common.imageRatio.horizontal"],
      thumbnails: {
        default: "/images/image_ratioes/horizontal_default.png",
        hover: "/images/image_ratioes/horizontal_hover.png",
        active: "/images/image_ratioes/horizontal_hover.png",
      },
    },
    {
      value: "vertical",
      text: i18n.messages[language]["engine.common.imageRatio.vertical"],
      thumbnails: {
        default: "/images/image_ratioes/vertical_default.png",
        hover: "/images/image_ratioes/vertical_hover.png",
        active: "/images/image_ratioes/vertical_hover.png",
      },
    },
  ];
  if (includes.length > 0) {
    return imageRatios.filter((item) => {
      return includes.includes(item.value);
    });
  }
  return imageRatios;
};
const getImageResizes = (language = i18n.locale, type = null) => {
  if (type == "widget_image") {
    return [
      {
        value: "cover",
        text: i18n.messages[language]["engine.common.imageResize.crop"],
        thumbnails: {
          default: "/images/image_resizes/crop_default.png",
          hover: "/images/image_resizes/crop_hover.png",
          active: "/images/image_resizes/crop_hover.png",
        },
      },
      {
        value: "contain",
        text: i18n.messages[language]["engine.common.imageResize.fit"],
        thumbnails: {
          default: "/images/image_resizes/fit_default.png",
          hover: "/images/image_resizes/fit_hover.png",
          active: "/images/image_resizes/fit_hover.png",
        },
      },
    ];
  }

  if (type == "widget_image_gallery") {
    return [
      {
        value: "original",
        text: i18n.messages[language]["engine.common.imageResize.original"],
        thumbnails: {
          default: "/images/image_resizes/original_default.png",
          hover: "/images/image_resizes/original_hover.png",
          active: "/images/image_resizes/original_hover.png",
        },
      },
      {
        value: "crop",
        text: i18n.messages[language]["engine.common.imageResize.crop"],
        thumbnails: {
          default: "/images/image_resizes/crop_default.png",
          hover: "/images/image_resizes/crop_hover.png",
          active: "/images/image_resizes/crop_hover.png",
        },
      },
      {
        value: "fit",
        text: i18n.messages[language]["engine.common.imageResize.fit"],
        thumbnails: {
          default: "/images/image_resizes/fit_default.png",
          hover: "/images/image_resizes/fit_hover.png",
          active: "/images/image_resizes/fit_hover.png",
        },
      },
    ];
  }

  return [
    {
      value: "crop",
      text: i18n.messages[language]["engine.common.imageResize.crop"],
      thumbnails: {
        default: "/images/image_resizes/crop_default.png",
        hover: "/images/image_resizes/crop_hover.png",
        active: "/images/image_resizes/crop_hover.png",
      },
    },
    {
      value: "fit",
      text: i18n.messages[language]["engine.common.imageResize.fit"],
      thumbnails: {
        default: "/images/image_resizes/fit_default.png",
        hover: "/images/image_resizes/fit_hover.png",
        active: "/images/image_resizes/fit_hover.png",
      },
    },
  ];
};
const getWidgetWidthTypes = (language = i18n.locale) => {
  return [
    { 
      value: "full", 
      label: i18n.messages[language]['engine.common.size.width.lblFullWidth'],
    },
    { 
      value: "fixed", 
      label: i18n.messages[language]['engine.common.size.width.lblFixedWidth'],
    },
  ];
};
const getWidgetHeightTypes = (language = i18n.locale) => {
  return [
    { 
      value: "auto", 
      label: i18n.messages[language]['engine.common.size.height.lblAutoHeight'],
    },
    { 
      value: "fixed", 
      label: i18n.messages[language]['engine.common.size.height.lblFixedHeight'],
    },
  ];
};
const getBackgroundTypes = (language = i18n.locale) => {
  return [
    {
      value: "none",
      text: i18n.messages[language][
        "engine.manageAppearance.theme.background.lblTypeTransparent"
      ],
    },
    {
      value: "color",
      text: i18n.messages[language][
        "engine.manageAppearance.theme.background.lblTypeColor"
      ],
    },
    {
      value: "gradient",
      text: i18n.messages[language][
        "engine.manageAppearance.theme.background.lblTypeGradient"
      ],
    },
    {
      value: "image",
      text: i18n.messages[language][
        "engine.manageAppearance.theme.background.lblTypeImage"
      ],
    },
    {
      value: "video",
      text: i18n.messages[language][
        "engine.manageAppearance.theme.background.lblTypeVideo"
      ],
    },
  ];
};
const getFontSizes = (type = null) => {
  switch (type) {
    case "responsive": // for mobile | tablet
      return [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 21, text: "21 px" },
        { value: 22, text: "22 px" },
        { value: 23, text: "23 px" },
        { value: 24, text: "24 px" },
        { value: 25, text: "25 px" },
        { value: 26, text: "26 px" },
        { value: 27, text: "27 px" },
        { value: 28, text: "28 px" },
        { value: 29, text: "29 px" },
        { value: 30, text: "30 px" },
        { value: 31, text: "31 px" },
        { value: 32, text: "32 px" },
        { value: 33, text: "33 px" },
        { value: 34, text: "34 px" },
        { value: 35, text: "35 px" },
        { value: 36, text: "36 px" },
        { value: 37, text: "37 px" },
        { value: 39, text: "39 px" },
        { value: 41, text: "41 px" },
        { value: 44, text: "44 px" },
        { value: 45, text: "45 px" },
        { value: 46, text: "46 px" },
        { value: 47, text: "47 px" },
        { value: 48, text: "48 px" },
        { value: 49, text: "49 px" },
        { value: 50, text: "50 px" },
      ];
    case "8_14":
      return [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
      ];
    case "8_18":
      return [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
      ];
    case "8_24":
      return [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
      ];
    case "8_30":
      return [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
        { value: 26, text: "26 px" },
        { value: 28, text: "28 px" },
        { value: 30, text: "30 px" },
      ];
    case "8_200":
      return [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
        { value: 26, text: "26 px" },
        { value: 28, text: "28 px" },
        { value: 30, text: "30 px" },
        { value: 32, text: "32 px" },
        { value: 34, text: "34 px" },
        { value: 36, text: "36 px" },
        { value: 40, text: "40 px" },
        { value: 44, text: "44 px" },
        { value: 48, text: "48 px" },
        { value: 52, text: "52 px" },
        { value: 56, text: "56 px" },
        { value: 60, text: "60 px" },
        { value: 66, text: "66 px" },
        { value: 72, text: "72 px" },
        { value: 80, text: "80 px" },
        { value: 100, text: "100 px" },
        { value: 140, text: "140 px" },
        { value: 160, text: "160 px" },
        { value: 180, text: "180 px" },
        { value: 200, text: "200 px" },
      ];
    case "8_60":
      return [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
        { value: 26, text: "26 px" },
        { value: 28, text: "28 px" },
        { value: 30, text: "30 px" },
        { value: 32, text: "32 px" },
        { value: 34, text: "34 px" },
        { value: 36, text: "36 px" },
        { value: 40, text: "40 px" },
        { value: 44, text: "44 px" },
        { value: 48, text: "48 px" },
        { value: 52, text: "52 px" },
        { value: 56, text: "56 px" },
        { value: 60, text: "60 px" },
      ];
    case "16_60":
      return [
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
        { value: 26, text: "26 px" },
        { value: 28, text: "28 px" },
        { value: 30, text: "30 px" },
        { value: 32, text: "32 px" },
        { value: 34, text: "34 px" },
        { value: 36, text: "36 px" },
        { value: 40, text: "40 px" },
        { value: 44, text: "44 px" },
        { value: 48, text: "48 px" },
        { value: 52, text: "52 px" },
        { value: 56, text: "56 px" },
        { value: 60, text: "60 px" },
      ];
    case "16_200":
      return [
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
        { value: 26, text: "26 px" },
        { value: 28, text: "28 px" },
        { value: 30, text: "30 px" },
        { value: 32, text: "32 px" },
        { value: 34, text: "34 px" },
        { value: 36, text: "36 px" },
        { value: 40, text: "40 px" },
        { value: 44, text: "44 px" },
        { value: 48, text: "48 px" },
        { value: 52, text: "52 px" },
        { value: 56, text: "56 px" },
        { value: 60, text: "60 px" },
        { value: 66, text: "66 px" },
        { value: 72, text: "72 px" },
        { value: 80, text: "80 px" },
        { value: 100, text: "100 px" },
        { value: 140, text: "140 px" },
        { value: 160, text: "160 px" },
        { value: 180, text: "180 px" },
        { value: 200, text: "200 px" },
      ];
    default: // 8_200 (all)
      return [
        { value: 8, text: "8 px" },
        { value: 9, text: "9 px" },
        { value: 10, text: "10 px" },
        { value: 11, text: "11 px" },
        { value: 12, text: "12 px" },
        { value: 13, text: "13 px" },
        { value: 14, text: "14 px" },
        { value: 15, text: "15 px" },
        { value: 16, text: "16 px" },
        { value: 17, text: "17 px" },
        { value: 18, text: "18 px" },
        { value: 19, text: "19 px" },
        { value: 20, text: "20 px" },
        { value: 22, text: "22 px" },
        { value: 24, text: "24 px" },
        { value: 26, text: "26 px" },
        { value: 28, text: "28 px" },
        { value: 30, text: "30 px" },
        { value: 32, text: "32 px" },
        { value: 34, text: "34 px" },
        { value: 36, text: "36 px" },
        { value: 40, text: "40 px" },
        { value: 44, text: "44 px" },
        { value: 48, text: "48 px" },
        { value: 52, text: "52 px" },
        { value: 56, text: "56 px" },
        { value: 60, text: "60 px" },
        { value: 66, text: "66 px" },
        { value: 72, text: "72 px" },
        { value: 80, text: "80 px" },
        { value: 100, text: "100 px" },
        { value: 140, text: "140 px" },
        { value: 160, text: "160 px" },
        { value: 180, text: "180 px" },
        { value: 200, text: "200 px" },
      ];
  }
};

// === Text ===
const getTextAlignsX = () => {
  return [
    {
      value: "start",
      thumbnails: {
        default: "/images/text_align_x/left_default.png?v=1",
        hover: "/images/text_align_x/left_hover.png?v=1",
        active: "/images/text_align_x/left_active.png?v=1",
      },
    },
    {
      value: "center",
      thumbnails: {
        default: "/images/text_align_x/center_default.png?v=1",
        hover: "/images/text_align_x/center_hover.png?v=1",
        active: "/images/text_align_x/center_active.png?v=1",
      },
    },
    {
      value: "end",
      thumbnails: {
        default: "/images/text_align_x/right_default.png?v=1",
        hover: "/images/text_align_x/right_hover.png?v=1",
        active: "/images/text_align_x/right_active.png?v=1",
      },
    },
  ];
};

// === Input ===
import InputColumn1 from "@components_system/Shared/Images/InputColumn/InputColumn1.vue";
import InputColumn2 from "@components_system/Shared/Images/InputColumn/InputColumn2.vue";
import inputLayoutBox from "@components_system/Shared/Images/InputStyle/InputFieldStyleBox.vue";
import inputLayoutLine from "@components_system/Shared/Images/InputStyle/InputFieldStyleLine.vue";
// For Contact
const getInputColumns = (language = i18n.locale) => {
  return [
    {
      value: 1,
      label: i18n.messages[language]["engine.common.inputColumn.lblOne"],
      component: InputColumn1,
    },
    {
      value: 2,
      label: i18n.messages[language]["engine.common.inputColumn.lblTwo"],
      component: InputColumn2,
    },
  ];
};
const getInputLayouts = (language = i18n.locale) => {
  return [
    {
      value: "block",
      label: i18n.messages[language]["engine.common.inputStyle.lblNormal"],
      component: inputLayoutBox,
    },
    {
      value: "line",
      label: i18n.messages[language]["engine.common.inputStyle.lblOutline"],
      component: inputLayoutLine,
    },
  ];
};
// For Form
const getInputFieldColumn = (language = i18n.locale) => {
  return [
    {
      value: "one",
      label: i18n.messages[language]["engine.common.inputColumn.lblOne"],
      thumbnails: {
        default: "images/image_input_column/input_column_one_default.png",
        hover: "images/image_input_column/input_column_one_hover.png",
        active: "images/image_input_column/input_column_one_hover.png",
      },
    },
    {
      value: "two",
      label: i18n.messages[language]["engine.common.inputColumn.lblTwo"],
      thumbnails: {
        default: "images/image_input_column/input_column_two_default.png",
        hover: "images/image_input_column/input_column_two_hover.png",
        active: "images/image_input_column/input_column_two_hover.png",
      },
    },
  ];
};
const getInputStyleField = (language = i18n.locale) => {
  return [
    {
      value: "normal",
      label: i18n.messages[language]["engine.common.inputStyle.lblNormal"],
      thumbnails: {
        default: "images/image_input_style/input_style_normal_default.png",
        hover: "images/image_input_style/input_style_normal_hover.png",
        active: "images/image_input_style/input_style_normal_hover.png",
      },
    },
    {
      value: "outline",
      label: i18n.messages[language]["engine.common.inputStyle.lblOutline"],
      thumbnails: {
        default: "images/image_input_style/input_style_outline_default.png",
        hover: "images/image_input_style/input_style_outline_hover.png",
        active: "images/image_input_style/input_style_outline_hover.png",
      },
    },
  ];
};

// === Button ===
const getButtonStyle = () => {
  return [
    {
      value: "square",
      thumbnails: {
        default: "/images/button_style/square_default.png?v=1",
        hover: "/images/button_style/square_hover.png?v=1",
        active: "/images/button_style/square_active.png?v=1",
      },
    },
    {
      value: "rounded",
      thumbnails: {
        default: "/images/button_style/round_default.png?v=1",
        hover: "/images/button_style/round_hover.png?v=1",
        active: "/images/button_style/round_active.png?v=1",
      },
    },
    {
      value: "rounder",
      thumbnails: {
        default: "/images/button_style/rounder_default.png?v=1",
        hover: "/images/button_style/rounder_hover.png?v=1",
        active: "/images/button_style/rounder_active.png?v=1",
      },
    },
  ];
};
import Cart from "../components_system/Shared/Images/Cart/Cart.vue";
import Cart_outline from "../components_system/Shared/Images/Cart/Cart_outline.vue";
import Basket from "../components_system/Shared/Images/Cart/Basket.vue";
import Basket_outline from "../components_system/Shared/Images/Cart/Basket_outline.vue";
import Bag from "../components_system/Shared/Images/Cart/Bag.vue";
import Bag_outline from "../components_system/Shared/Images/Cart/Bag_outline.vue";

const getAddToCartButtonIconOption = () => {
  return [
    { value: "cart", component: Cart },
    { value: "basket", component: Basket },
    { value: "bag", component: Bag },
    { value: "cart_outline", component: Cart_outline },
    { value: "basket_outline", component: Basket_outline },
    { value: "bag_outline", component: Bag_outline },
  ]
};

// === Slide ===//

const getSlideArrowLayout = () => {
  return [
    // {
    //   value: "01",
    //   thumbnails: {
    //     default: "/images/slide_arrow_layout/layout01_default.png?v=1",
    //     hover: "/images/slide_arrow_layout/layout01_hover.png?v=1",
    //     active: "/images/slide_arrow_layout/layout01_hover.png?v=1",
    //   },
    // },
    {
      value: "02",
      thumbnails: {
        default: "/images/slide_arrow_layout/layout02_default.png?v=1",
        hover: "/images/slide_arrow_layout/layout02_hover.png?v=1",
        active: "/images/slide_arrow_layout/layout02_hover.png?v=1",
      },
    },
    {
      value: "03",
      thumbnails: {
        default: "/images/slide_arrow_layout/layout03_default.png?v=1",
        hover: "/images/slide_arrow_layout/layout03_hover.png?v=1",
        active: "/images/slide_arrow_layout/layout03_hover.png?v=1",
      },
    },
    {
      value: "04",
      thumbnails: {
        default: "/images/slide_arrow_layout/layout04_default.png?v=1",
        hover: "/images/slide_arrow_layout/layout04_hover.png?v=1",
        active: "/images/slide_arrow_layout/layout04_hover.png?v=1",
      },
    },
  ];
};

// === Page ===
const getPageUrlReserve = () => {
  return [
    "_api",
    "_api-account",
    "_api-billing",
    "_api-seo",
    "_api-shipping",
    "_api-sms",
    "album",
    "bestsellerproduct",
    "blog",
    "calendar",
    "giftcard",
    "cart-giftcard",
    "cart",
    "category",
    "categoryalbum",
    "categoryblog",
    "categorygiftcard",
    "compare",
    "contact",
    "cookie-declaration",
    "category-giftcard",
    "giftcard",
    "faq",
    "form",
    "forum",
    "informpayment",
    "flashsale",
    "member",
    "onlinepayment",
    "orderstatus",
    "ordertracking",
    "printorder",
    "privacyandterms",
    "privacy-policy",
    "product",
    "productbrand",
    "promotion-discount",
    "promotion-shipping",
    "quotations",
    "quotations-form",
    "search",
    "tag",
    "termscondition",
    "ae",
    "br",
    "cn",
    "da",
    "de",
    "en",
    "fr",
    "id",
    "in",
    "jp",
    "kh",
    "ko",
    "la",
    "mm",
    "mn",
    "my",
    "pt",
    "ru",
    "sw",
    "th",
    "tw",
    "vn",
    "it",
    "pl",
    "fi",
    "he",
  ];
};
const getPageUrlSystem = () => {
  return [
    "_api",
    "_api-account",
    "_api-billing",
    "_api-seo",
    "_api-shipping",
    "_api-sms",
    "album",
    "bestsellerproduct",
    "blog",
    "calendar",
    "giftcard",
    "cart-giftcard",
    "cart",
    "category",
    "categoryalbum",
    "categoryblog",
    "categorygiftcard",
    "compare",
    "contact",
    "cookie-declaration",
    "category-giftcard",
    "giftcard",
    "faq",
    "flashsale",
    "form",
    "forum",
    "informpayment",
    "member",
    "onlinepayment",
    "orderstatus",
    "ordertracking",
    "printorder",
    "privacyandterms",
    "privacy-policy",
    "product",
    "productbrand",
    "promotion-discount",
    "promotion-shipping",
    "quotations",
    "quotations-form",
    "search",
    "tag",
    "termscondition",
  ];
};
const getPageGroupTypes = (language = i18n.locale) => {
  return [
    {
      value: "custom",
      name: i18n.messages[language]["engine.commonPage.pageGroupType.custom"],
      child: [
        {
          value: "section",
          name: i18n.messages[language]["engine.commonPage.pageType.section"],
        },
      ],
    },
    {
      value: "system",
      name: i18n.messages[language]["engine.commonPage.pageGroupType.system"],
      child: [
        {
          value: "content_list",
          name: i18n.messages[language][
            "engine.commonPage.pageType.contentList"
          ],
        },
        {
          value: "content_item",
          name: i18n.messages[language][
            "engine.commonPage.pageType.contentItem"
          ],
        },
        {
          value: "album_list",
          name: i18n.messages[language]["engine.commonPage.pageType.albumList"],
        },
        {
          value: "album_item",
          name: i18n.messages[language]["engine.commonPage.pageType.albumItem"],
        },
        // {
        //   value: "forum_list",
        //   name: i18n.messages[language]['engine.commonPage.pageType.forumList'],
        // },
        {
          value: "form_item",
          name: i18n.messages[language]["engine.commonPage.pageType.formItem"],
        },
        {
          value: "contact",
          name: i18n.messages[language]["engine.commonPage.pageType.contact"],
        },
        {
          value: "product_list",
          name: i18n.messages[language][
            "engine.commonPage.pageType.productList"
          ],
        },
        {
          value: "product_item",
          name: i18n.messages[language][
            "engine.commonPage.pageType.productItem"
          ],
        },
        {
          value: "product_brand",
          name: i18n.messages[language][
            "engine.commonPage.pageType.productBrandList"
          ],
        },
        {
          value: "giftcard_list",
          name: i18n.messages[language][
            "engine.commonPage.pageType.giftcard_list"
          ],
        },
        {
          value: "inform_payment",
          name: i18n.messages[language][
            "engine.commonPage.pageType.informPayment"
          ],
        },
        {
          value: "online_payment",
          name: i18n.messages[language][
            "engine.commonPage.pageType.onlinePayment"
          ],
        },
        {
          value: "order_tracking",
          name: i18n.messages[language][
            "engine.commonPage.pageType.orderTracking"
          ],
        },
        {
          value: "terms_condition",
          name: i18n.messages[language]["engine.commonPage.pageType.terms"],
        },
        {
          value: "faq",
          name: i18n.messages[language]["engine.commonPage.pageType.faqList"],
        },
        {
          value: "event_calendar",
          name: i18n.messages[language]['engine.commonPage.pageType.eventCalendar'],
        },
        {
          value: "policy",
          name: i18n.messages[language]['engine.commonPage.pageType.policy'],
        },
        {
          value: "quotation_form_item",
          name: i18n.messages[language]["engine.commonPage.pageType.quotationFormItem"],
        },
        {
          value: "search",
          name: i18n.messages[language]["engine.commonPage.pageType.search"],
        },
      ],
    },
  ];
};
const getPagePermissionMemberTypes = (language = i18n.locale) => {
  return [
    {
      value: "all",
      label:
        i18n.messages[language][
          "engine.managePage.pageAddEdit.permission.member.lblMemberTypeAll"
        ],
    },
    {
      value: "groups",
      label:
        i18n.messages[language][
          "engine.managePage.pageAddEdit.permission.member.lblMemberTypeGroup"
        ],
    },
  ];
};

// === Product ===
const getPageProductLayouts = () => {
  return [
    {
      value: "01",
      thumbnails: {
        default: "/images/product_layouts/layout01_default.png",
        hover: "/images/product_layouts/layout01_hover.png",
        active: "/images/product_layouts/layout01_hover.png",
      },
    },
    // {
    //   value: "02",
    //   thumbnails: {
    //     'default': "/images/product_layouts/layout02_default.png",
    //     'hover': "/images/product_layouts/layout02_hover.png",
    //     'active': "/images/product_layouts/layout02_hover.png",
    //   },
    // },
    {
      value: "03",
      thumbnails: {
        default: "/images/product_layouts/layout03_default.png",
        hover: "/images/product_layouts/layout03_hover.png",
        active: "/images/product_layouts/layout03_hover.png",
      },
    },
  ];
};
const getPageProductFlashSaleLayouts = () => {
  return [
    {
      value: "01",
      thumbnails: {
        default: "/images/flash_sale_layouts/layout01_default.png",
        hover: "/images/flash_sale_layouts/layout01_hover.png",
        active: "/images/flash_sale_layouts/layout01_hover.png",
      },
    },
    {
      value: "02",
      thumbnails: {
        default: "/images/flash_sale_layouts/layout02_default.png",
        hover: "/images/flash_sale_layouts/layout02_hover.png",
        active: "/images/flash_sale_layouts/layout02_hover.png",
      },
    },
  ];
};
const getPageProductDataTypes = (language = i18n.locale, permissions = {}) => {
  return [
    {
      id: "category",
      label: i18n.messages[language]["engine.commonProduct.dataType.category"],
    },
    {
      id: "brand",
      label: i18n.messages[language]["engine.commonProduct.dataType.brand"],
      isPermission: (permissions.isProductBrand == '0') ? false : true,
    },
    {
      id: "best_seller",
      label: i18n.messages[language]["engine.commonProduct.dataType.bestSeller"],
    },
    {
      id: "promotion",
      label: i18n.messages[language]["engine.commonProduct.dataType.promotion"],
    },
    {
      id: "flash_sale",
      label: i18n.messages[language]["engine.commonProduct.dataType.flashSale"],
    }
  ];
};

const getPageProductSortByList = (language = i18n.locale) => {
  return [
    {
      value: "featured",
      text: i18n.messages[language]["website.pageProduct.sortBy.lblFeatured"],
    },
    {
      value: "recently",
      text: i18n.messages[language]["website.pageProduct.sortBy.lblRecently"],
    },
    {
      value: "best_seller",
      text: i18n.messages[language]["website.pageProduct.sortBy.lblBestSeller"],
    },
    {
      value: "price_lh",
      text: i18n.messages[language]["website.pageProduct.sortBy.lblPriceLH"],
    },
    {
      value: "price_hl",
      text: i18n.messages[language]["website.pageProduct.sortBy.lblPriceHL"],
    },
    {
      value: "name",
      text: i18n.messages[language]["website.pageProduct.sortBy.lblName"],
    },
    // {
    //   value: "number_order",
    //   text: "Number Order",
    // },
  ];
};

const getProductPromotionTypes = (language = i18n.locale) => {
  return [
    {
      id: "discount",
      name: i18n.messages[language][
        "engine.commonProduct.promotionType.discount"
      ],
    },
    {
      id: "shipping",
      name: i18n.messages[language][
        "engine.commonProduct.promotionType.shipping"
      ],
    },
    {
      id: "free",
      name: i18n.messages[language][
        "engine.commonProduct.promotionType.free"
      ],
    },
    {
      id: "installment_zero",
      name: i18n.messages[language][
        "engine.commonProduct.promotionType.installment_zero"
      ],
    },
  ];
};

const getProductDetailLayout = (language = i18n.locale) => {
  return [
    { 
      value: "container", 
      label: i18n.messages[language]['engine.common.size.width.lblFixWidth'],
      thumbnails: {
        default: "/images/product_detail_width/fixWidth_default.png",
        hover: "/images/product_detail_width/fixWidth_hover.png",
        active: "/images/product_detail_width/fixWidth_hover.png",
      },
    },
    
    { 
      value: "container-fluid", 
      label: i18n.messages[language]['engine.common.size.width.lblFullWidth'],
      thumbnails: {
        default: "/images/product_detail_width/fullWidth_default.png",
        hover: "/images/product_detail_width/fullWidth_hover.png",
        active: "/images/product_detail_width/fullWidth_hover.png",
      },
    },
  ];
}

const getWidgetImageShape = (language = i18n.locale) => {
  return [
    {
      id: "square",
      value: "square",
      label:
        i18n.messages[language][
          "engine.sidebarAddWidget.widget.image.lblSquare"
        ],
      text: i18n.messages[language]["engine.sidebar.widget.image.lblSquare"],
      thumbnails: {
        default: "/images/image_shape/square_default.png?v=1",
        hover: "/images/image_shape/square_hover.png?v=1",
        active: "/images/image_shape/square_active.png?v=1",
      },
    },
    {
      id: "rounded",
      value: "rounded",
      label:
        i18n.messages[language][
          "engine.sidebarAddWidget.widget.image.lblRounded"
        ],
      text: i18n.messages[language]["engine.sidebar.widget.image.lblRounded"],
      thumbnails: {
        default: "/images/image_shape/rounded_default.png?v=1",
        hover: "/images/image_shape/rounded_hover.png?v=1",
        active: "/images/image_shape/rounded_active.png?v=1",
      },
    },
    {
      id: "circle",
      value: "circle",
      label:
        i18n.messages[language][
          "engine.sidebarAddWidget.widget.image.lblCircle"
        ],
      text: i18n.messages[language]["engine.sidebar.widget.image.lblCircle"],
      thumbnails: {
        default: "/images/image_shape/circle_default.png?v=1",
        hover: "/images/image_shape/circle_hover.png?v=1",
        active: "/images/image_shape/circle_active.png?v=1",
      },
    },
  ];
};
const getWidgetProductDataTypes = (language = i18n.locale, permissions = {}) => {
  return [
    {
      id: "category",
      value: "category",
      text: i18n.messages[language]["engine.commonProduct.dataType.category"],
    },
    {
      id: "brand",
      value: "brand",
      text: i18n.messages[language]["engine.commonProduct.dataType.brand"],
      isPermission: (permissions.isProductBrand == '0') ? false : true,
    },
    {
      id: "best_seller",
      value: "best_seller",
      text: i18n.messages[language]["engine.commonProduct.dataType.bestSeller"],
    },
    {
      id: "promotion",
      value: "promotion",
      text: i18n.messages[language]["engine.commonProduct.dataType.promotion"],
    },
    {
      id: "flash_sale",
      value: "flash_sale",
      text: i18n.messages[language]["engine.commonProduct.dataType.flashSale"],
    },
    {
      id: "custom",
      value: "custom",
      text: i18n.messages[language]["engine.commonProduct.dataType.custom"]
    },
  ];
};

import widgetProductLayout1 from "@components_system/Shared/Images/Layouts/WidgetProduct/Layout1.vue"
import widgetProductLayout2 from "@components_system/Shared/Images/Layouts/WidgetProduct/Layout2.vue"
import widgetProductLayout3 from "@components_system/Shared/Images/Layouts/WidgetProduct/Layout3.vue"
import widgetProductLayoutSlide from "@components_system/Shared/Images/Layouts/WidgetProduct/LayoutSlide.vue"

const getWidgetProductLayout = () => {
  return [
    {
      id: "01",
      value: "01",
      thumbnails: {
        default: "/images/widget_product_layout/layout_01_default.png?v=1",
        hover: "/images/widget_product_layout/layout_01_hover.png?v=1",
        active: "/images/widget_product_layout/layout_01_hover.png?v=1",
      },
      component: widgetProductLayout1
    },
    {
      id: "02",
      value: "02",
      thumbnails: {
        default: "/images/widget_product_layout/layout_02_default.png?v=1",
        hover: "/images/widget_product_layout/layout_02_hover.png?v=1",
        active: "/images/widget_product_layout/layout_02_hover.png?v=1",
      },
      component: widgetProductLayout2
    },
    {
      id: "03",
      value: "03",
      thumbnails: {
        default: "/images/widget_product_layout/layout_03_default.png?v=1",
        hover: "/images/widget_product_layout/layout_03_hover.png?v=1",
        active: "/images/widget_product_layout/layout_03_hover.png?v=1",
      },
      component: widgetProductLayout3
    },
    {
      id: "slide",
      value: "slide",
      thumbnails: {
        default: "/images/widget_product_layout/layout_slide_default.png?v=1",
        hover: "/images/widget_product_layout/layout_slide_hover.png?v=1",
        active: "/images/widget_product_layout/layout_slide_hover.png?v=1",
      },
      component: widgetProductLayoutSlide
    },
  ];
}

// === Contact & Map ===
import SectionPageContactLayout1 from "@components_system/Shared/Images/Layouts/SectionPageContact/Layout1.vue";
import SectionPageContactLayout2 from "@components_system/Shared/Images/Layouts/SectionPageContact/Layout2.vue";
import SectionPageContactLayout3 from "@components_system/Shared/Images/Layouts/SectionPageContact/Layout3.vue";
import MapTypeGoogleMap from "@components_system/Shared/Images/MapType/MapTypeGoogleMap.vue";
import MapTypeImageMap from "@components_system/Shared/Images/MapType/MapTypeImageMap.vue";
import MapTypeNoneMap from "@components_system/Shared/Images/MapType/MapTypeNoneMap.vue";
const getSectionPageContactLayouts = () => {
  return [
    {
      value: "1",
      thumbnails: {
        default: "/images/page_contact_layout/layout01_default.png",
        hover: "/images/page_contact_layout/layout01_hover.png",
        active: "/images/page_contact_layout/layout01_hover.png",
      },
      component: SectionPageContactLayout1,
    },
    {
      value: "2",
      thumbnails: {
        default: "/images/page_contact_layout/layout02_default.png",
        hover: "/images/page_contact_layout/layout02_hover.png",
        active: "/images/page_contact_layout/layout02_hover.png",
      },
      component: SectionPageContactLayout2,
    },
    {
      value: "3",
      thumbnails: {
        default: "/images/page_contact_layout/layout03_default.png",
        hover: "/images/page_contact_layout/layout03_hover.png",
        active: "/images/page_contact_layout/layout03_hover.png",
      },
      component: SectionPageContactLayout3,
    },
  ];
};
const getMapTypes = (language = i18n.locale) => {
  return [
    {
      value: "googleMap",
      label:
        i18n.messages[language][
          "engine.manageSectionPageContact.sidebar.manage.lblMapTypeGoogleMap"
        ],
      thumbnails: {
        default: "/images/map_type/googleMap_default.png",
        hover: "/images/map_type/googleMap_hover.png",
        active: "/images/map_type/googleMap_hover.png",
      },
      component: MapTypeGoogleMap,
    },
    {
      value: "imageMap",
      label:
        i18n.messages[language][
          "engine.manageSectionPageContact.sidebar.manage.lblMapTypeImageMap"
        ],
      thumbnails: {
        default: "/images/map_type/image_default.png",
        hover: "/images/map_type/image_hover.png",
        active: "/images/map_type/image_hover.png",
      },
      component: MapTypeImageMap,
    },
    {
      value: "none",
      label:
        i18n.messages[language][
          "engine.manageSectionPageContact.sidebar.manage.lblMapTypeNone"
        ],
      thumbnails: {
        default: "/images/map_type/none_default.png",
        hover: "/images/map_type/none_hover.png",
        active: "/images/map_type/none_hover.png",
      },
      component: MapTypeNoneMap,
    },
  ];
};

// === Blog ===
import widgetBlogLayout2 from "@components_system/Shared/Images/Layouts/WidgetBlog/Layout2.vue"
import widgetBlogLayout3 from "@components_system/Shared/Images/Layouts/WidgetBlog/Layout3.vue"
import widgetBlogLayout4 from "@components_system/Shared/Images/Layouts/WidgetBlog/Layout4.vue"
import widgetBlogLayout5 from "@components_system/Shared/Images/Layouts/WidgetBlog/Layout5.vue"
import widgetBlogLayout6 from "@components_system/Shared/Images/Layouts/WidgetBlog/Layout6.vue"
import pageBlogLayout1 from "@components_system/Shared/Images/Layouts/PageBlog/Layout1.vue"
import pageBlogLayout2 from "@components_system/Shared/Images/Layouts/PageBlog/Layout2.vue"
import pageBlogLayout3 from "@components_system/Shared/Images/Layouts/PageBlog/Layout3.vue"
import pageBlogLayout4 from "@components_system/Shared/Images/Layouts/PageBlog/Layout4.vue"
import pageBlogLayout5 from "@components_system/Shared/Images/Layouts/PageBlog/Layout5.vue"
const getLayoutBlog = () => {
  return [
    { value: "04", component: pageBlogLayout4 },
    { value: "05", component: pageBlogLayout5 },
    { value: "01", component: pageBlogLayout1 },
    { value: "02", component: pageBlogLayout2 },
    { value: "03", component: pageBlogLayout3 },
  ]
};

const getWidgetBlogLayout = () => {
  return [
    { value: "layout_02", component: widgetBlogLayout2 },
    { value: "layout_03", component: widgetBlogLayout3 },
    { value: "layout_06", component: widgetBlogLayout6 },
    { value: "layout_04", component: widgetBlogLayout4 },
    { value: "layout_05", component: widgetBlogLayout5 },
  ]
}

// === Album ===
import SectionPageAlbumLayout1 from "@components_system/Shared/Images/Layouts/SectionPageAlbum/Layout1.vue";
import SectionPageAlbumLayout2 from "@components_system/Shared/Images/Layouts/SectionPageAlbum/Layout2.vue";
import SectionPageAlbumLayout3 from "@components_system/Shared/Images/Layouts/SectionPageAlbum/Layout3.vue";
import WidgetAlbumLayout1 from "@components_system/Shared/Images/Layouts/WidgetAlbum/Layout1.vue";
import WidgetAlbumLayout2 from "@components_system/Shared/Images/Layouts/WidgetAlbum/Layout2.vue";
import WidgetAlbumLayout3 from "@components_system/Shared/Images/Layouts/WidgetAlbum/Layout3.vue";
const getSectionPageAlbumLayouts = () => {
  return [
    { value: "1", component: SectionPageAlbumLayout1 },
    { value: "2", component: SectionPageAlbumLayout2 },
    { value: "3", component: SectionPageAlbumLayout3 },
  ];
};
const getWidgetAlbumLayouts = () => {
  return [
    { value: "1", component: WidgetAlbumLayout1 },
    { value: "2", component: WidgetAlbumLayout2 },
    { value: "3", component: WidgetAlbumLayout3 },
  ];
};

// === Gallery ===
import WidgetGalleryLayout1 from "@components_system/Shared/Images/Layouts/WidgetGallery/Layout1.vue";
import WidgetGalleryLayout2 from "@components_system/Shared/Images/Layouts/WidgetGallery/Layout2.vue";
import WidgetGalleryLayout3 from "@components_system/Shared/Images/Layouts/WidgetGallery/Layout3.vue";
const getWidgetGalleryLayouts = () => {
  return [
    { value: "1", component: WidgetGalleryLayout1 },
    { value: "2", component: WidgetGalleryLayout2 },
    { value: "3", component: WidgetGalleryLayout3 },
  ];
};

// === Slide ===
import SlideNavLayout1 from "@components_system/Shared/Images/SlideNav/Layout1.vue";
import SlideNavLayout2 from "@components_system/Shared/Images/SlideNav/Layout2.vue";
import SlideNavLayout3 from "@components_system/Shared/Images/SlideNav/Layout3.vue";
import SlideNavLayout4 from "@components_system/Shared/Images/SlideNav/Layout4.vue";
const getSlideNavLayouts = () => {
  return [
    { value: "1", component: SlideNavLayout1 },
    { value: "2", component: SlideNavLayout2 },
    { value: "3", component: SlideNavLayout3 },
    { value: "4", component: SlideNavLayout4 },
  ];
};

// === Payment ===
const getPayment = (language = i18n.locale, isEngine = true) => {
  let env = isEngine ? 'engine' : 'website'
  return {
    img_2c2p: {
      img: "/images/payment/img_2c2p.webp",
      credit : ["visa","mastercard","jcb","unionPay","americanexpress"],
      label: i18n.messages[language][`${env}.common.payment.lbl_2c2p`] 
    },
    img_2c2p_installment: {
      img: "/images/payment/img_2c2p.webp",
      credit : ["visa","mastercard","jcb","unionPay","americanexpress"],
      label: i18n.messages[language][`${env}.common.payment.lbl_2c2p_installment`] 
    },
    img_bbl: {
      img: "/images/payment/img_bbl.webp",
      credit : ["visa","mastercard","jcb","unionPay","americanexpress"],
      label: i18n.messages[language][`${env}.common.payment.lbl_bbl`] 
    },
    img_cod: {
      img: "/images/payment/img_cod.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_cod`] 
    }, 
    img_gb: { 
      img: "/images/payment/img_gb.webp",
      credit : ["visa","mastercard","jcb","americanexpress"],
      label: i18n.messages[language][`${env}.common.payment.lbl_gb`] 
    },
    img_kbank: {
      img: "/images/payment/img_kbank.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_kbank`] 
    },
    img_kpgw_mcc : { 
      img: "/images/payment/img_kbank.webp",
      credit : ["visa","mastercard","jcb","unionPay"],
      label: i18n.messages[language][`${env}.common.payment.lbl_kpgw_mcc`] 
    },
    img_kpgw_dcc : { 
      img: "/images/payment/img_kbank.webp",
      credit : ["visa","mastercard","jcb","unionPay"],
      label: i18n.messages[language][`${env}.common.payment.lbl_kpgw_dcc`] 
    },
    img_kpgw_installment : { 
      img: "/images/payment/img_kbank.webp",
      credit : ["visa","mastercard","jcb","unionPay"],
      label: i18n.messages[language][`${env}.common.payment.lbl_kpgw_installment`] 
    },
    img_kpgw_thaiqr : { 
      img: "/images/payment/img_kbank.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_kpgw_thaiqr`] 
    },
    img_kpgw_wechat : { 
      img: "/images/payment/img_kbank.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_kpgw_wechat`] 
    },
    img_kpgw_alipay : { 
      img: "/images/payment/img_kbank.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_kpgw_alipay`] 
    },
    img_kpgw_payplus : { 
      img: "/images/payment/img_kbank.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_kpgw_payplus`] 
    },
    img_omise: {
      img: "/images/payment/img_omise.webp",
      credit : ["visa","mastercard","jcb"],
      label: i18n.messages[language][`${env}.common.payment.lbl_omise`] 
    },
    img_paypal: {
      img: "/images/payment/img_paypal.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_paypal`] 
    },
    img_paysolution: {
      img: "/images/payment/img_paysolution.webp",
      credit : ["visa","mastercard","jcb","unionPay","americanexpress"],
      label: i18n.messages[language][`${env}.common.payment.lbl_paysolution`] 
    },
    img_paysolution_installment: {
      img: "/images/payment/img_paysolution.webp",
      credit : ["visa","mastercard","jcb","unionPay","americanexpress"],
      label: i18n.messages[language][`${env}.common.payment.lbl_paysolution`] 
    },
    img_paysolution_qrcode: {
      img: "/images/payment/img_paysolution.webp",
      credit : ["visa","mastercard","jcb","unionPay","americanexpress"],
      label: i18n.messages[language][`${env}.common.payment.lbl_paysolution`] 
    },
    img_promptpay: {
      img: "/images/payment/img_promptpay.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_promptpay`] 
    },
    // tranfer
    img_bay_bbl: {
      img: "/images/payment/img_bay_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bay_bbl`] 
    }, 
    img_bac_bbl:{ 
      img: "/images/payment/img_bac_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bac_bbl`] 
    }, 
    img_bbl_bbl:{ 
      img: "/images/payment/img_bbl_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bbl_bbl`] 
    }, 
    img_cimb_bbl:{ 
      img: "/images/payment/img_cimb_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_cimb_bbl`] 
    }, 
    img_gsba_bbl:{ 
      img: "/images/payment/img_gsba_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_gsba_bbl`] 
    }, 
    img_icbc_bbl:{ 
      img: "/images/payment/img_icbc_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_icbc_bbl`] 
    }, 
    img_kbank_bbl:{ 
      img: "/images/payment/img_kbank_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_kbank_bbl`] 
    }, 
    img_kk_bbl:{ 
      img: "/images/payment/img_kk_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_kk_bbl`] 
    }, 
    img_ktb_bbl: { 
      img: "/images/payment/img_ktb_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_ktb_bbl`] 
    }, 
    img_lhbank_bbl:{ 
      img: "/images/payment/img_lhbank_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_lhbank_bbl`] 
    }, 
    img_scb_bbl:{ 
      img: "/images/payment/img_scb_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_scb_bbl`] 
    },
    img_tisco_bbl: {
      img: "/images/payment/img_tisco_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_tisco_bbl`] 
    }, 
    img_ibank_bbl:{ 
      img: "/images/payment/img_ibank_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_ibank_bbl`] 
    }, 
    img_ttb_bbl:{ 
      img: "/images/payment/img_ttb_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_ttb_bbl`] 
    }, 
    img_uob_bbl:{ 
      img: "/images/payment/img_uob_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_uob_bbl`] 
    }, 
    img_scbt_bbl:{ 
      img: "/images/payment/img_scbt_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_scbt_bbl`] 
    },
    img_first_choice_bbl: {
      img: "/images/payment/img_first_choice_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_first_choice_bbl`] 
    }, 
    img_citi_bbl:{ 
      img: "/images/payment/img_citi_bbl.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_citi_bbl`] 
    }, 
    img_bca: {
      img: "/images/payment/img_bca.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bca`] 
    } ,
    img_bni: {
      img: "/images/payment/img_bni.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bni`] 
    } ,
    img_mandiri: {
      img: "/images/payment/img_mandiri.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_mandiri`] 
    } ,
    img_bri: {
      img: "/images/payment/img_bri.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bri`] 
    } ,
    img_bsi: {
      img: "/images/payment/img_bsi.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bsi`] 
    } ,
    img_cimb_niaga: {
      img: "/images/payment/img_cimb_niaga.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_cimb_niaga`] 
    } ,
    img_permata_bank: {
      img: "/images/payment/img_permata_bank.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_permata_bank`] 
    } ,
    img_bank_mega: {
      img: "/images/payment/img_bank_mega.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bank_mega`] 
    } ,
    img_danamon: {
      img: "/images/payment/img_danamon.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_danamon`] 
    } ,
    img_panin_bank: {
      img: "/images/payment/img_panin_bank.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_panin_bank`] 
    } ,
    img_bank_btn: {
      img: "/images/payment/img_bank_btn.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_bank_btn`] 
    } ,
    img_hcbc: {
      img: "/images/payment/img_hcbc.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_hcbc`] 
    } ,
    img_visa: {
      img: "/images/payment/img_visa.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_visa`] 
    } ,
    img_mastercard: {
      img: "/images/payment/img_mastercard.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_mastercard`] 
    } ,
    img_qris: {
      img: "/images/payment/img_qris.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_qris`] 
    } ,
    img_gopay: {
      img: "/images/payment/img_gopay.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_gopay`] 
    } ,
    img_ovo: {
      img: "/images/payment/img_ovo.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_ovo`] 
    } ,
    img_shopee_pay: {
      img: "/images/payment/img_shopee_pay.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_shopee_pay`] 
    } ,
    img_dana: {
      img: "/images/payment/img_dana.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_dana`] 
    } ,
    img_link_aja: {
      img: "/images/payment/img_link_aja.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_link_aja`] 
    } ,
    img_indomaret: {
      img: "/images/payment/img_indomaret.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_indomaret`] 
    } ,
    img_alfamart: {
      img: "/images/payment/img_alfamart.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_alfamart`] 
    } ,
    img_maybank: {
      img: "/images/payment/img_maybank.webp",
      label: i18n.messages[language][`${env}.common.payment.lbl_maybank`] 
    } ,
    img_xendit: {
      img: null,
      label: i18n.messages[language][`${env}.common.payment.lbl_xendit`] 
    } ,
  };
};

// === Shipping ===
const getShipping = (language = i18n.locale) => {
  return {
    img_thailandpost: {
      img: "/images/shipping/img_thailandpost.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_thailandpost"],
    },
    img_ems: {
      img: "/images/shipping/img_ems.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_ems"],
    },
    img_kerry: {
      img: "/images/shipping/img_kexexpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_kerry"],
    },
    img_scgexpress: {
      img: "/images/shipping/img_scgexpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_scgexpress"],
    },
    img_jtexpress: {
      img: "/images/shipping/img_jtexpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_jtexpress"],
    },
    img_dhl: {
      img: "/images/shipping/img_dhl.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_dhl"],
    },
    img_flashexpress: {
      img: "/images/shipping/img_flashexpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_flashexpress"],
    },
    img_fedex: {
      img: "/images/shipping/img_fedex.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_fedex"],
    },
    img_honestbee: {
      img: "/images/shipping/img_honestbee.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_honestbee"],
    },
    img_alphafast: {
      img: "/images/shipping/img_alphafast.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_alphafast"],
    },
    img_nimexpress: {
      img: "/images/shipping/img_nimexpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_nimexpress"],
    },
    img_cjlogistics: {
      img: "/images/shipping/img_cjlogistics.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_cjlogistics"],
    },
    img_ninjavan: {
      img: "/images/shipping/img_ninjavan.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_ninjavan"],
    },
    img_aramex: {
      img: "/images/shipping/img_aramex.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_aramex"],
    },
    img_tplogistics: {
      img: "/images/shipping/img_tplogistics.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_tplogistics"],
    },
    img_InterExpress: {
      img: "/images/shipping/img_InterExpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_InterExpress"],
    },
    img_bestexpress: {
      img: "/images/shipping/img_bestexpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_bestexpress"],
    },
    img_j_and_t: {
      img: "/images/shipping/img_j_and_t.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_j_and_t"],
    },
    img_sap: {
      img: "/images/shipping/img_sap.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_sap"],
    },
    img_jne: {
      img: "/images/shipping/img_jne.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_jne"],
    },
    img_si_cepat: {
      img: "/images/shipping/img_si_cepat.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_si_cepat"],
    },
    img_tiki: {
      img: "/images/shipping/img_tiki.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_tiki"],
    },
    img_ninja_express: {
      img: "/images/shipping/img_ninja_express.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_ninja_express"],
    },
    img_lion_parcel: {
      img: "/images/shipping/img_lion_parcel.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_lion_parcel"],
    },
    img_grab: {
      img: "/images/shipping/img_grab.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_grab"],
    },
    img_gojek: {
      img: "/images/shipping/img_gojek.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_gojek"],
    },
    img_dhl_indo: {
      img: "/images/shipping/img_dhl_indo.webp",
      label: i18n.messages[language]["engine.common.payment.img_dhl_indo"],
    },
    img_fed_ex: {
      img: "/images/shipping/img_fed_ex.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_fed_ex"],
    },
    img_anteraja: {
      img: "/images/shipping/img_anteraja.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_anteraja"],
    },
    img_deliveree: {
      img: "/images/shipping/img_deliveree.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_deliveree"],
    },
    img_jetExpress: {
      img: "/images/shipping/img_jetExpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_jetExpress"],
    },
    img_lalamove: {
      img: "/images/shipping/img_lalamove.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_lalamove"],
    },
    img_paxel: {
      img: "/images/shipping/img_paxel.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_paxel"],
    },
    img_wahanaExpress: {
      img: "/images/shipping/img_wahanaExpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_wahanaExpress"],
    },
    img_spxexpress: {
      img: "/images/shipping/img_spxexpress.webp",
      label: i18n.messages[language]["engine.common.payment.lbl_spxexpress"],
    },
  };
};

// === Interactive ===
import EffectLayout1 from "@components_system/Shared/Images/HoverEffect/EffectsLayout1.vue";
import EffectLayout2 from "@components_system/Shared/Images/HoverEffect/EffectsLayout2.vue";
import EffectLayout3 from "@components_system/Shared/Images/HoverEffect/EffectsLayout3.vue";
import EffectLayout4 from "@components_system/Shared/Images/HoverEffect/EffectsLayout4.vue";
const getWidgetInteractiveEffects = (language = i18n.locale) => {
  return [
    {
      label: i18n.messages[language]["engine.common.hoverEffect.lblNone"],
      value: "none",
      component: EffectLayout1,
    },
    {
      label: i18n.messages[language]["engine.common.hoverEffect.lblZoom"],
      value: "zoom",
      component: EffectLayout2,
    },
    {
      label: i18n.messages[language]["engine.common.hoverEffect.lblFade"],
      value: "fade",
      component: EffectLayout3,
    },
    {
      label: i18n.messages[language]["engine.common.hoverEffect.lblFadeZoom"],
      value: "fade_zoom",
      component: EffectLayout4,
    },
  ];
};
// faq
const getFAQIconStyleRight = () => {
  return [
    {
      value: "up_down_right",
      thumbnails: {
        default: "/images/faq_icon_style/up_down_right_default.png?v=1",
        hover: "/images/faq_icon_style/up_down_right_hover.png?v=1",
        active: "/images/faq_icon_style/up_down_right_active.png?v=1",
      },
    },
    {
      value: "right_down_right",
      thumbnails: {
        default: "/images/faq_icon_style/right_down_right_default.png?v=1",
        hover: "/images/faq_icon_style/right_down_right_hover.png?v=1",
        active: "/images/faq_icon_style/right_down_right_active.png?v=1",
      },
    },
    {
      value: "plus_minus_right",
      thumbnails: {
        default: "/images/faq_icon_style/plus_minus_right_default.png?v=1",
        hover: "/images/faq_icon_style/plus_minus_right_hover.png?v=1",
        active: "/images/faq_icon_style/plus_minus_right_active.png?v=1",
      },
    },
  ];
};
const getFAQIconStyleLeft = () => {
  return [
    {
      value: "up_down_left",
      thumbnails: {
        default: "/images/faq_icon_style/up_down_left_default.png?v=1",
        hover: "/images/faq_icon_style/up_down_left_hover.png?v=1",
        active: "/images/faq_icon_style/up_down_left_active.png?v=1",
      },
    },
    {
      value: "right_down_left",
      thumbnails: {
        default: "/images/faq_icon_style/right_down_left_default.png?v=1",
        hover: "/images/faq_icon_style/right_down_left_hover.png?v=1",
        active: "/images/faq_icon_style/right_down_left_active.png?v=1",
      },
    },
    {
      value: "plus_minus_left",
      thumbnails: {
        default: "/images/faq_icon_style/plus_minus_left_default.png?v=1",
        hover: "/images/faq_icon_style/plus_minus_left_hover.png?v=1",
        active: "/images/faq_icon_style/plus_minus_left_active.png?v=1",
      },
    },
  ];
};
const getSectionPageEventCalendarLayouts = () => {
  return [
    {
      value: "1",
      thumbnails: {
        default: "/images/page_event_calendar_layout/layout01_default.png",
        hover: "/images/page_event_calendar_layout/layout01_hover.png",
        active: "/images/page_event_calendar_layout/layout01_hover.png",
      },
    },
    {
      value: "2",
      thumbnails: {
        default: "/images/page_event_calendar_layout/layout02_default.png",
        hover: "/images/page_event_calendar_layout/layout02_hover.png",
        active: "/images/page_event_calendar_layout/layout02_hover.png",
      },
    },
  ];
};

const getSectionWidgetEventCalendarLayouts = () => {
  return [
    {
      value: "1",
      thumbnails: {
        default: "/images/widget_event_calendar_layout/layout01_default.png",
        hover: "/images/widget_event_calendar_layout/layout01_hover.png",
        active: "/images/widget_event_calendar_layout/layout01_hover.png",
      },
    },
    {
      value: "2",
      thumbnails: {
        default: "/images/widget_event_calendar_layout/layout02_default.png",
        hover: "/images/widget_event_calendar_layout/layout02_hover.png",
        active: "/images/widget_event_calendar_layout/layout02_hover.png",
      },
    },
  ];
};

const getTextWidgetAnimationDirection = (language = i18n.locale) => {
  return [
    { 
      value: "btt", 
      label: i18n.messages[language]['engine.manageText.sidebar.lblTextAnimationSettingDirectionBTT'],
    },
    { 
      value: "ttb", 
      label: i18n.messages[language]['engine.manageText.sidebar.lblTextAnimationSettingDirectionTTB'],
    },
    { 
      value: "ltr", 
      label: i18n.messages[language]['engine.manageText.sidebar.lblTextAnimationSettingDirectionLTR'],
    },
    { 
      value: "rtl", 
      label: i18n.messages[language]['engine.manageText.sidebar.lblTextAnimationSettingDirectionRTL'],
    },
  ];
};

const getImageWidgetAnimationDirection = (language = i18n.locale, type) => {
  let option = [
    { 
      value: "btt", 
      label: i18n.messages[language]['engine.common.animation.lblSettingDirectionBTT'],
    },
    { 
      value: "ttb", 
      label: i18n.messages[language]['engine.common.animation.lblSettingDirectionTTB'],
    },
    { 
      value: "ltr", 
      label: i18n.messages[language]['engine.common.animation.lblSettingDirectionLTR'],
    },
    { 
      value: "rtl", 
      label: i18n.messages[language]['engine.common.animation.lblSettingDirectionRTL'],
    },
  ];
  let optionCenter = [
    { 
      value: "cnt", 
      label: i18n.messages[language]['engine.common.animation.lblSettingDirectionCenter'],
    },
  ]
  return type == 'slideFwd' ? [...optionCenter, ...option] : option
};

const getTableStyle = () => {
  return [
    {
      value: "1",
      thumbnails: {
        default: "/images/table_style/style1_default.png",
        hover: "/images/table_style/style1_hover.png",
        active: "/images/table_style/style1_hover.png",
      },
    },
    {
      value: "2",
      thumbnails: {
        default: "/images/table_style/style2_default.png",
        hover: "/images/table_style/style2_hover.png",
        active: "/images/table_style/style2_hover.png",
      },
    },
    {
      value: "3",
      thumbnails: {
        default: "/images/table_style/style3_default.png",
        hover: "/images/table_style/style3_hover.png",
        active: "/images/table_style/style3_hover.png",
      },
    },
  ];
};

const getTableHeaderBorderStyle = () => {
  return [
    {
      value: "none",
      thumbnails: {
        default: "/images/table_border_style/style_none_default.png",
        hover: "/images/table_border_style/style_none_hover.png",
        active: "/images/table_border_style/style_none_active.png",
      },
    },
    {
      value: "all",
      thumbnails: {
        default: "/images/table_border_style/style_all_default.png",
        hover: "/images/table_border_style/style_all_hover.png",
        active: "/images/table_border_style/style_all_active.png",
      },
    },
    {
      value: "bottom",
      thumbnails: {
        default: "/images/table_border_style/style_bottom_default.png",
        hover: "/images/table_border_style/style_bottom_hover.png",
        active: "/images/table_border_style/style_bottom_active.png",
      },
    },
    {
      value: "horizontal",
      thumbnails: {
        default: "/images/table_border_style/style_horizontal_default.png",
        hover: "/images/table_border_style/style_horizontal_hover.png",
        active: "/images/table_border_style/style_horizontal_active.png",
      },
    },
    {
      value: "vertical",
      thumbnails: {
        default: "/images/table_border_style/style_vertical_default.png",
        hover: "/images/table_border_style/style_vertical_hover.png",
        active: "/images/table_border_style/style_vertical_active.png",
      },
    },
  ];
};

const getTableBodyBorderStyle = () => {
  return [
    {
      value: "none",
      thumbnails: {
        default: "/images/table_border_style/style_none_default.png",
        hover: "/images/table_border_style/style_none_hover.png",
        active: "/images/table_border_style/style_none_active.png",
      },
    },
    {
      value: "all",
      thumbnails: {
        default: "/images/table_border_style/style_all_default.png",
        hover: "/images/table_border_style/style_all_hover.png",
        active: "/images/table_border_style/style_all_active.png",
      },
    },
    {
      value: "inner",
      thumbnails: {
        default: "/images/table_border_style/style_inner_default.png",
        hover: "/images/table_border_style/style_inner_hover.png",
        active: "/images/table_border_style/style_inner_active.png",
      },
    },
    {
      value: "horizontal",
      thumbnails: {
        default: "/images/table_border_style/style_horizontal_default.png",
        hover: "/images/table_border_style/style_horizontal_hover.png",
        active: "/images/table_border_style/style_horizontal_active.png",
      },
    },
    {
      value: "vertical",
      thumbnails: {
        default: "/images/table_border_style/style_vertical_default.png",
        hover: "/images/table_border_style/style_vertical_hover.png",
        active: "/images/table_border_style/style_vertical_active.png",
      },
    },
  ];
};

const getPolicyTypes = (language = i18n.locale) => {
  return [
    {
      id: null, 
      name: i18n.messages[language]['engine.managePage.pageAddEdit.info.msgPolicyChoose'],
    },
    { 
      id: "privacy", 
      name: i18n.messages[language]['engine.commonPage.pageType.policy.privacy'],
    },
    { 
      id: "cookie", 
      name: i18n.messages[language]['engine.commonPage.pageType.policy.cookie'],
    },
  ]
}

const getPageGiftcardLayouts = () => {
  return [
    {
      value: "01",
      thumbnails: {
        default: "/images/giftcard_layouts/layout01_default.png",
        hover: "/images/giftcard_layouts/layout01_hover.png",
        active: "/images/giftcard_layouts/layout01_hover.png",
      },
    },
    {
      value: "02",
      thumbnails: {
        'default': "/images/giftcard_layouts/layout02_default.png",
        'hover': "/images/giftcard_layouts/layout02_hover.png",
        'active': "/images/giftcard_layouts/layout02_hover.png",
      },
    },
  ];
};

// === Instagram Feed ===
import WidgetInstagramLayout1 from "@components_system/Shared/Images/Layouts/WidgetInstagramFeed/Layout1.vue";
import WidgetInstagramLayout2 from "@components_system/Shared/Images/Layouts/WidgetInstagramFeed/Layout2.vue";
const getWidgetInstagramLayouts = () => {
  return [
    { value: 1, component: WidgetInstagramLayout1 },
    { value: 2, component: WidgetInstagramLayout2 },
  ];
};

// === Tab ===
import WidgetTabDesign1 from "@components_system/Shared/Images/Layouts/WidgetTab/Design1.vue";
import WidgetTabDesign2 from "@components_system/Shared/Images/Layouts/WidgetTab/Design2.vue";
import WidgetTabDesign3 from "@components_system/Shared/Images/Layouts/WidgetTab/Design3.vue";
import WidgetTabDesign4 from "@components_system/Shared/Images/Layouts/WidgetTab/Design4.vue";
const getWidgetTabDesigns = () => {
  return [
    { value: 1, component: WidgetTabDesign1 },
    { value: 2, component: WidgetTabDesign2 },
    { value: 3, component: WidgetTabDesign3 },
    { value: 4, component: WidgetTabDesign4 },
  ];
};

const getInstallmentLabelDesign = () => {
  return [
    { 
      value: 'rounded' , 
      thumbnails : {
        'default' : "/images/product_installment_style/style_rounded_default.png",
        'hover' : "/images/product_installment_style/style_rounded_hover.png",
        'active' : "/images/product_installment_style/style_rounded_active.png",
      } 
    },
    { 
      value: 'square' , 
      thumbnails : {
        'default' : "/images/product_installment_style/style_square_default.png",
        'hover' : "/images/product_installment_style/style_square_hover.png",
        'active' : "/images/product_installment_style/style_square_active.png",
      } 
    },
  ]
}

export {
  getAlignsX,
  getAlignsY,
  getDateRanges,
  getSortByList,
  getNumItems,
  getImageRatios,
  getImageResizes,
  getWidgetWidthTypes,
  getWidgetHeightTypes,
  getBackgroundTypes,
  getFontSizes,
  getTextAlignsX,
  getInputColumns,
  getInputLayouts,
  getInputFieldColumn,
  getInputStyleField,
  getButtonStyle,
  getAddToCartButtonIconOption,
  getSlideArrowLayout,
  getPageUrlReserve,
  getPageUrlSystem,
  getPageGroupTypes,
  getPagePermissionMemberTypes,
  getPageProductLayouts,
  getPageProductFlashSaleLayouts,
  getPageProductDataTypes,
  getPageProductSortByList,
  getProductPromotionTypes,
  getProductDetailLayout,
  getWidgetProductDataTypes,
  getWidgetProductLayout,
  getWidgetImageShape,
  getSectionPageContactLayouts,
  getMapTypes,
  getSectionPageAlbumLayouts,
  getWidgetAlbumLayouts,
  getWidgetGalleryLayouts,
  getSlideNavLayouts,
  getPayment,
  getShipping,
  getLayoutBlog,
  getWidgetBlogLayout,
  getWidgetInteractiveEffects,
  getFAQIconStyleRight,
  getFAQIconStyleLeft,
  getSectionPageEventCalendarLayouts,
  getSectionWidgetEventCalendarLayouts,
  getTextWidgetAnimationDirection,
  getImageWidgetAnimationDirection,
  getTableStyle,
  getTableHeaderBorderStyle,
  getTableBodyBorderStyle,
  getPolicyTypes,
  getWidgetInstagramLayouts,
  getPageGiftcardLayouts,
  getWidgetTabDesigns,
  getInstallmentLabelDesign,
};
export default {
  getAlignsX,
  getAlignsY,
  getDateRanges,
  getSortByList,
  getNumItems,
  getImageRatios,
  getImageResizes,
  getWidgetWidthTypes,
  getWidgetHeightTypes,
  getBackgroundTypes,
  getFontSizes,

  getTextAlignsX,

  getInputColumns,
  getInputLayouts,
  getInputFieldColumn,
  getInputStyleField,

  getButtonStyle,
  getAddToCartButtonIconOption,

  getSlideArrowLayout,

  getPageUrlReserve,
  getPageUrlSystem,
  getPageGroupTypes,
  getPagePermissionMemberTypes,

  getPageProductLayouts,
  getPageProductFlashSaleLayouts,
  getPageProductDataTypes,
  getPageProductSortByList,
  getProductPromotionTypes,
  getProductDetailLayout,
  getWidgetProductDataTypes,
  getWidgetProductLayout,

  getWidgetImageShape,

  getSectionPageContactLayouts,
  getMapTypes,

  getSectionPageAlbumLayouts,
  getWidgetAlbumLayouts,

  getWidgetGalleryLayouts,

  getSlideNavLayouts,

  getPayment,
  getShipping,

  getLayoutBlog,
  getWidgetBlogLayout,
  getWidgetInteractiveEffects,

  getFAQIconStyleRight,
  getFAQIconStyleLeft,

  getSectionPageEventCalendarLayouts,

  getSectionWidgetEventCalendarLayouts,
  
  getTextWidgetAnimationDirection,
  getImageWidgetAnimationDirection,

  getTableStyle,
  getTableHeaderBorderStyle,
  getTableBodyBorderStyle,

  getPolicyTypes,
  getWidgetInstagramLayouts,
  getPageGiftcardLayouts,
  getWidgetTabDesigns,
  getInstallmentLabelDesign,
};
